import { render, staticRenderFns } from "./PortfolioDateSelector.vue?vue&type=template&id=c252ca56&scoped=true"
import script from "./PortfolioDateSelector.vue?vue&type=script&lang=js"
export * from "./PortfolioDateSelector.vue?vue&type=script&lang=js"
import style0 from "./PortfolioDateSelector.vue?vue&type=style&index=0&id=c252ca56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c252ca56",
  null
  
)

export default component.exports